<template>
  <div>
      <v-card class="mx-auto content-personal" max-width="95%" style="padding:30px; font-size: 14px;" :flat='true'>
    <!-- <v-card class="mx-auto main-container"> -->
      <v-card-text>
<!-- <template>

      <v-card class="mx-auto content-personal" max-width="95%" style="padding:30px; font-size: 14px;" :flat='true'> -->


        <!-- <v-row>
          <v-col class="pa-0">
            <h1 style="padding-top: -5px;"> 
  			    	<b style="padding-left: 10px !important;">Организатор</b>
	      		</h1>
          </v-col>
        </v-row> -->
        <v-row>
          <!-- <v-col cols="12" lg="7" class="pa-0">
            <h2> 
  			    	<b>Федеральное государственное бюджетное учреждение <a href="http://nrcki.ru/">«Национальный исследовательский центр «Курчатовский институт»</a></b>
	      		</h2>
          </v-col> -->
          <v-col class="pa-0" >
            <!-- <v-img
              :src="logo1"
              class="logo"
              style="height: 70px !important; width: 300px !important;"
            ></v-img> -->
            <v-img
              :src="logo1"
              class="logo"
              style=" width: 289px !important;"
              
            ></v-img>
          </v-col>
        </v-row>

        <!-- <v-row class="pt-5">
          <v-col cols="6" class="pa-0">
            <v-img
              :src="logo2"
              class="logo"
              style="height: 70px !important; width: 300px !important;"
            ></v-img>
          </v-col>
          <v-col cols="6" class="pa-0">
            <h2 style="padding-top: -5px;"> 
  			    	<b style="padding-left: 10px !important;">При участии научно-образовательной национальной ассоциации «Исследовательские установки МЕГА-класса»</b>
	      		</h2>
          </v-col>
        </v-row> -->

        <!-- <v-row>
          <br>
          <h2 class="mt-4">Состав программного комитета: </h2>
          <ul>
            <li><b>Научный руководитель и председатель</b> Ковальчук Михаил Валентинович, президент НИЦ «Курчатовский институт»;</li>
            <li><b>Заместитель председател</b>  – Камболов М.А.,	директор НИЦ «Курчатовский институт»;</li>
            <li><b>Заместитель председателя</b>  – Дьякова Юлия Алексеевна, первый заместитель директора НИЦ «Курчатовский институт» по науке;</li>
            <li>Белушкин А.В., заместитель руководителя ККСНИ по научной работе;</li>
            <li>Борисов К.Е., главный учёный секретарь Центра, заместитель председателя организационного комитета;</li>
            <li>Воронин В.В., заместитель директора НИЦ «Курчатовский институт» - ПИЯФ по научной работе (по согласованию);</li>
            <li>Горчаков С.Е., директор НИЦ «Курчатовский институт» - ПИЯФ (по согласованию);</li>
            <li>Звонарёв С.В., заместитель начальника отдела управления проектами ККСНИ; </li>
            <li>Иванов С.В., директор НИЦ «Курчатовский институт» - ИФВЭ;</li>
            <li>Коробец Б.Н., ректор Дальневосточного федерального университета (по согласованию);</li>
            <li>Логачёв П.В., директор  института ядерной физики имени Г.И. Будкера СО РАН (по согласованию);</li>
            <li>Новикова Н.Н., главный научный сотрудник отдела синхротронно-нейтронных и рентгеновских исследований ККСНИ;</li>
            <li>Пресняков М.Ю., начальник управления по созданию исследовательской установки «СИЛА»;</li>
            <li>Трубников Г.В., директор Объединенного института ядерных исследований (по согласованию);</li>
            <li>Таргонский А. В., заместитель начальника управления по науке управления по созданию исследовательской установки «СИЛА»;</li>
            <li>Шевченко В.И.	, ректор Национального исследовательского ядерного университета «МИФИ» (по согласованию);</li>
            <li>Якунин С.Н., первый заместитель руководителя Комплекса ККСНИ;</li>
          </ul>

          <br>
          <h2 class="mt-4">Состав организационного комитета:</h2>
          <ul>
            <li><b>Председатель </b> –  Благов А.Е., вице-президент Центра;</li>
            <li><b>Заместитель председателя </b> – Марченков Н.В.,  руководитель ККСНИ;</li>
            <li><b>Секретарь </b> – Чубова Н.М., заместитель руководителя ККСНИ по общим и научным вопросам;</li>
            <li>Анурова М.И.	-	начальник полиграфического отдела;</li>
            <li>Агафонова О.А.	-	заместитель начальника управления по созданию исследовательской установки «СИЛА»;</li>
            <li>Борисова П.А.	-	начальник отдела нейтронных экспериментальных станций ККСНИ;</li>
            <li>Биниенко К.А.	-	заместитель начальника управления делами президента Центра - начальник отдела протокола;</li>
            <li>Велигжанин А.А. -	начальник отдела синхротронных экспериментальных станций ККСНИ;</li>
            <li>Гохгут К.А.	-	начальник управления по связям с общественностью;</li>
            <li>Гончаренко М.С.	-	заместитель начальника отдела управления проектами ККСНИ;</li>
            <li>Демьянова Н.А.	-	заместитель начальника отдела нейтронных экспериментальных станций ККСНИ;</li>
            <li>Заплаткина А.А.	-	лаборант-исследователь отделения новых ускорительных технологий ККСНИ;</li>
            <li>Ибрагимов Э.С.	-	лаборант-исследователь отдела синхротронно-нейтронных и рентгеновских исследований ККСНИ;</li>
            <li>Короткова Т.А.	-	ведущий специалист группы научно-технического сопровождения ККСНИ;</li>
            <li>Лебедева Л.А.	-	начальник отдела научно-технического сопровождения ККСНИ;</li>
            <li>Наплёкова Е.В.	-	начальник группы сопровождения договоров ККСНИ;</li>
            <li>Светогоров Р.Д.	-	заместитель руководителя ККСНИ по взаимодействию с пользователями;</li>
            <li>Федин А.Е. - специалист отдела управления проектами ККСНИ;</li>
            <li>Чагрин А.С. -	первый заместитель главного учёного секретаря Центра;</li>
          </ul>

        </v-row> -->

        <v-row>
          <h2 class="mt-4">Контакты:</h2>
        </v-row>
        <v-row>
          <p class="ml-4">e-mail: Synchrotron@nrcki.ru
            <br>123182 Россия, Москва, пл. Академика Курчатова, д. 1, НИЦ "Курчатовский институт", ККСНИ</p>

        </v-row>
        </v-card-text>
      </v-card>

  </div>
</template>
<script>
import logo1 from '../../src/assets/Logo-01_cor.png';
// import logo2 from '../../src/assets/logo_ru.png';

export default {
  name: 'Orgs',
  data: () => ({
    logo1,
    // logo2,
  }),

};
</script>

<style scoped>
.zoom-image >>> .v-image__image {
  transition: transform 0.3s ease-in-out;
}
.zoom-image:hover >>> .v-image__image {
  transform: scale(1.1); 
}
</style>

<style lang="scss" scoped>
  .content-personal{
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
    background-color: #fff;
    border-radius: 13px!important;
}
.theme--light.v-application {
    background: rgb(248, 248, 248) !important;
    color: rgba(0, 0, 0, 0.87);
}

@media screen and (max-width:767px) {
  .content-personal {
    max-width: 90% !important;
  }
  .content-personal__header {
    flex-direction: column;
  }
}
</style>
